module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921054149_T.8ea7951b.jpg";